import { environment } from 'src/environments/environment';


const apiVentas = environment.apiVentas;


export const RESOURCES = {
  departamento: `${apiVentas}departamento`,
  tipoDocumento: `${apiVentas}tipo-documento`,
  barrio: `${apiVentas}barrio`,
  estrato: `${apiVentas}estrato`,
  clasesServicios: `${apiVentas}clase-servicio`,
  login: `${apiVentas}auth/login`,
  refreshSession: `${apiVentas}reauth`,
  estadosVentas: `${apiVentas}estado-venta`,
  estadosServicios: `${apiVentas}estados-servicios`,
  departamentosConCobertura: `${apiVentas}departamentos/listwithcoverage`,
  planesGenerales: `${apiVentas}planes/list`,
  ventas: `${apiVentas}venta`,
  detallesVentaByVenta: `${apiVentas}detalle-venta/detalles/`,
  detallesCompletos: `${apiVentas}detalle-venta/detalles-completos`,
  validacionPostVenta: `${apiVentas}validacion-post-venta`,
  validacionPreVenta: `${apiVentas}validacion-pre-venta`,
  municipio: `${apiVentas}municipio`,
  plan: `${apiVentas}plan`,
  tercero: `${apiVentas}tercero`,
  detalleVenta: `${apiVentas}detalle-venta`,
  refreshToken: `${apiVentas}auth/refresh-token`,
  createVentasRecords: `${apiVentas}validacion-pre-venta/create-ventas-records`,
  pagoComision: `${apiVentas}pago-comision`,
  estadoComisionMetadata: `${apiVentas}pago-comision/estado-comision/metadata`,
  ventasComisionPorUsuario: `${apiVentas}detalle-venta/comision-por-usuario`,
  logout: `${apiVentas}auth/logout`,
  vendedores: `${apiVentas}tercero/buscar`,
  estadisticas: `${apiVentas}detalle-venta/estadisticas`,
  tipoAdjunto: `${apiVentas}tipo-adjunto`,
  documentoAdicionalVenta: `${apiVentas}documento-adicional-venta`,
  motivoNoEntrega: `${apiVentas}motivo-no-entrega`,
  CanalesComunicacion: `${apiVentas}canales-comunicacion`,
  leads: `${apiVentas}leads`,
  estadosLeads: `${apiVentas}estado-lead`,
  tipoInteres: `${apiVentas}tipos-interes`,
  tipoPrioridad: `${apiVentas}tipos-prioridad`,
  ResultadosComunicacion: `${apiVentas}resultados-comunicacion`,
  gestionLead: `${apiVentas}gestion-lead/gestion`,
  estadosGestion: `${apiVentas}estado-gestion`,
  geografia: `${apiVentas}geografia`,
};
